document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        Alpine.store('modals').register('cart', 'rightDrawer');

        document.body.addEventListener(
          'shapes:modalcart:afteradditem',
          (e) => {
            const shouldOpen =
              openOnAddToCart === true ||
              e.detail?.forceOpen === true;

            if (!shouldOpen) return;

            /*
             * Event önce body'den window'a bubble olur.
             *
             * Window tarafında:
             * - CartItems morph edilir
             * - CartFooter morph edilir
             * - Cart Count güncellenir
             *
             * Drawer'ı iki frame sonra açarak
             * yeni ürünlerin drawer'da hazır olmasını sağlıyoruz.
             */
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                Alpine.store('modals').open('cart');
              });
            });
          }
        );
      },
    };
  });
});